import TenMillions from 'blocks/TenMillions'
import locales from 'i18n/locales'
import { NavAndFooterLayout } from 'layouts/NavAndFooter'
import { getBanner } from 'pages/api/banner'
import { PageHead } from 'pages/Head'
import { injectI18n } from 'utils/i18n'
import { Accor } from './sections/Accor'
import { CampaignDataPreview } from './sections/CampaignDataPreview'
import { CommentsSection } from './sections/CommentsSection'
import { Dift } from './sections/Dift'
import { DiftCTA } from './sections/DiftCTA'
import { FlowSection } from './sections/Flow'
import { Hero } from './sections/Hero'
import { Impact } from './sections/Impact'
import { Impacts } from './sections/Impacts'
import { Individuals } from './sections/Individuals'
import { PercentData } from './sections/PercentData'
import { Press } from './sections/Press'
import { ProductsCTA } from './sections/ProductsCTA'
import { Quotes } from './sections/Quotes'
import { UseCases } from './sections/UseCases'
import type { Locales } from '@captaincause/types'
import type { NextPageWithLayout } from 'app'
import type { GetStaticProps, InferGetStaticPropsType } from 'next'

interface PageProps {}

export const getStaticProps: GetStaticProps<PageProps> = async context => {
  const i18n = await injectI18n(context.locale, [
    'dift.block',
    'faq.block',
    'ten-millions.block',
    'comments.block',
    'footer.component',
    'home.page',
    'metadata',
    'nav.component',
  ])

  const banner = await getBanner({ locale: context.locale as Locales })

  return {
    props: {
      banner,
      localizations: locales.SUPPORTED_LOCALES.map(locale => ({ locale })),
      ...i18n,
    },
  }
}

type InferredPageProps = InferGetStaticPropsType<typeof getStaticProps>
const Home: NextPageWithLayout<InferredPageProps> = () => (
  <>
    <PageHead
      head={{
        alternates: [
          {
            locale: 'fr',
            href: 'https://dift.com',
          },
          {
            locale: 'en',
            href: 'https://dift.com/en',
          },
        ],
      }}
    />
    <main id="main">
      <Hero />
      <Dift />
      <DiftCTA />
      <Individuals />
      <Impact />
      <FlowSection />
      <PercentData />
      <CampaignDataPreview />
      <CommentsSection />
      <UseCases />
      <Accor />
      <ProductsCTA />
      <Quotes />
      <Impacts />
      <TenMillions />
      <Press />
    </main>
  </>
)

Home.Layout = NavAndFooterLayout
Home.pagePropsOnLayout = true

export default Home
